import type { LightningGroup, LightningLine } from './config/types';

export const groupDuration = (group: LightningGroup): number =>
  Math.max(
    0,
    ...group.lines
      .filter((line) => line.enabled)
      .map((line) => line.delay + line.lifetime)
  );

// A shuffled bag visits every enabled position before replenishing. Avoid
// repeating the previous group's ID even at the boundary between bags.
export const shuffleGroups = (
  ids: string[],
  previous: string | null,
  random = Math.random
): string[] => {
  const bag = [...ids];
  for (let i = bag.length - 1; i > 0; i--) {
    const j = Math.floor(random() * (i + 1));
    [bag[i], bag[j]] = [bag[j], bag[i]];
  }
  if (bag.length > 1 && bag[0] === previous)
    [bag[0], bag[1]] = [bag[1], bag[0]];
  return bag;
};

export const lineEnvelope = (age: number, line: LightningLine): number => {
  if (age < 0 || age >= line.lifetime || !line.enabled) return 0;
  const fadeIn = Math.min(age / 0.015, 1);
  const fadeOut = Math.min(
    (line.lifetime - age) /
      Math.max(line.keyframes?.length ? 0.045 : line.lifetime * 0.55, 0.001),
    1
  );
  return fadeIn * fadeOut * fadeOut;
};
